// extracted by mini-css-extract-plugin
export default {"body":"InvitesPage_body__4Vc6C"};